import { render, staticRenderFns } from "./TemporaryAccessError.vue?vue&type=template&id=b6e406b8&scoped=true"
import script from "./TemporaryAccessError.vue?vue&type=script&lang=js"
export * from "./TemporaryAccessError.vue?vue&type=script&lang=js"
import style0 from "./TemporaryAccessError.vue?vue&type=style&index=0&id=b6e406b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e406b8",
  null
  
)

export default component.exports